import type { IPartyEventChipProps } from './IPartyEventChipProps';
import { eventLabel, eventTip } from './partyEventText';
import { partyColors } from './partyColors';

/** Подія в клітинці (прототип v4 pcal): кнопка в кольорах типу з лівою рамкою 3px, назва запису (без назви — номер) в один рядок, підказка «Тип · статус». */
export function PartyEventChip({ event, onOpen }: IPartyEventChipProps) {
  const c = partyColors(event.type.hue);
  return (
    <button type="button" className="pcal__ev" title={eventTip(event)} style={{ background: c.bg, color: c.fg, borderLeftColor: c.dot }} onClick={() => onOpen(event)}>
      {eventLabel(event)}
    </button>
  );
}
